<template>
  <el-header>
    <div class="header-left">
      <!--      <div class="receive car">-->
      <!--        <div class="icon"/>-->
      <!--        <span>急救车1</span>-->
      <!--      </div>-->
      <!--      <div class="send car">-->
      <!--        <div class="icon"/>-->
      <!--        <span>急救车2</span>-->
      <!--      </div>-->

    </div>
    <div class="header-text">
      <el-tooltip content="消息" placement="bottom" effect="light" :offset="10">
        <img src="@/assets/photos/message.png" alt="" @click="newTable= true">
      </el-tooltip>
      <el-dropdown>
        <div class="operation">
          <img src="@/assets/photos/avatar.png" alt="">
          <div class="user-operation">
            <span class="username">{{ hospitalName ? hospitalName + " - " : "" }}{{ getUserName }}</span>
            <i class="el-icon-arrow-down el-icon--right"/>
          </div>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item class="headerText" @click="changePassDialog('ruleForm')">
              修改密码
            </el-dropdown-item>
            <el-dropdown-item class="headerText" @click="showExitDialog=true">
              安全退出
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <change-password
        :change-pwd="changePwd"
        @closeChangeForm="changePwd=false"
      />

      <handle-message
        v-if="newTable"
        :new-table="newTable"
        :note-check-list="noteCheckList"
        @closeDialog="newTable= false"
      />
      <my-dialog-form
        form-title="提示"
        :width="400"
        :dialog-form-visible="showExitDialog"
        @confirmOk="Logout"
      >
        <template #body>
          <div>是否退出本系统？</div>
        </template>
      </my-dialog-form>
    </div>
  </el-header>
</template>

<script>
import { logout } from "@api/login";
import Cookies from "js-cookie";
import { mapState } from "vuex";

import ChangePassword from "@components/customDialog/ChangePassword";
import HandleMessage from "@/components/headers/HandleMessage";
import MyDialogForm from "@components/customDialog/MyDialogForm";

export default {
  name: "Header",
  components: {
    ChangePassword,
    HandleMessage,
    MyDialogForm,
  },
  data() {
    return {
      noteCheckList: [],
      changePwd: false,
      newTable: false,
      ruleForm: {
        oldPassword: "",
        newPassword: "",
        checkPwd: "",
      },
      formLabelWidth: "90px",
      showExitDialog: false, // 退出系统弹窗
    };
  },
  computed: {
    ...mapState({
      hospitalName: "hospitalName",
      userInfo: "userInfo",
    }),
    getUserName() {
      return this.userInfo.name;
    },
  },
  methods: {
    closeDialog() {
      this.noteCheckList = [];
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.changePwd = false;
    },

    changePassDialog(formName) {
      // 打开对话框之前,先将对话框清空
      this.ruleForm = [];
      this.changePwd = true;
    },
    /*
    * 退出登陆
    * */
    async Logout() {
      await logout();
      Cookies.remove("token");
      localStorage.removeItem("loginStatus");
      sessionStorage.clear();
      await this.$router.push("/login");
      this.$store.commit("deleteData");
    },
  }
};
</script>
<style scoped lang="scss">
.header-left {
  background: #FBFBFB;
  border-radius: 8px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666666;
  padding: 0 12px;
  cursor: pointer;

  .car {
    line-height: 32px;
    height: 32px;
    display: flex;
    align-items: center;
  }

  .car + .car::before {
    content: "";
    width: 1px;
    height: 16px;
    border-left: solid 1px #EDEDED;
    padding-left: 12px;
    margin-left: 12px;
  }

  .icon {
    width: 12px;
    height: 12px;
    display: inline-block;
    margin-right: 12px;
  }

  span {
    height: 32px;
    line-height: 32px;
  }
}

.receive {
  .icon {
    background: url(../../assets/photos2/voice-receive.png) center center no-repeat;
  }
}

.send {
  .icon {
    background: url(../../assets/photos2/voice-send.png) center center no-repeat;
  }

}

header.el-header {
  padding-left: 0;
  padding-right: 38px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-text {
  font-size: 20px;
  color: #efefef;
  cursor: pointer;

  img {
    margin-left: 38px;
  }

  .operation {
    display: flex;
    align-items: center;
  }

  .user-operation {
    padding-top: 2px;
  }

  .username {
    padding-left: 12px;
  }

  .welcomeText {
    line-height: 19px;
    float: left;
  }
}

.el-tabel__header-wrapper {
  width: 92px;
  height: 20px;
  font-size: 20px;
  font-weight: bold;
  color: #666666;
  background: #e4e1e1;
}

.welcomeText {
  cursor: default;
}
</style>

